import React from 'react';

import {MetricCountBySelection} from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/metric-count-by-menu';
import {CustomizeBuckets} from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/customize-buckets';
import {MultiAttributionMeasurement} from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/multi-attribution';

import type {RowProps} from '../catalog';
import styles from './index.module.styl';

export function SimpleMetricMeasurement(props: RowProps) {
  return (
    <div className={styles.measurement}>
      {props.children}
      <MetricCountBySelection {...props} />
      {/* buckets settings for distribution metrics */}
      <CustomizeBuckets
        {...props}
        isOpen={props.activeMenu?.menu === `customizeBuckets`}
        toggleOpen={() =>
          props.setActiveMenu?.(props.activeMenu?.menu === `customizeBuckets` ? null : {menu: `customizeBuckets`})
        }
      />
      {/* Multi Attribution selection */}
      <MultiAttributionMeasurement {...props} />
    </div>
  );
}
